import { Component }                      from '@angular/core';
import { MatDialogRef }                    from '@angular/material';
import { Globals }                        from './../common/globals';
import { UploadService }                  from './../shared/upload.service';
import { toNetParameterDate }             from './../common/functions';
import { MatSnackBar }                     from '@angular/material';


@Component({
  selector: 'sa-peak-import-dialog',
  template: require('./peak-import-dialog.component.html'),
  styles: [require('./peak-import-dialog.component.scss')]
})
export class PeakImportDialogComponent {

  public model: any = {
    delimiter: 'semicolon',
    importType: 'dateImport',
    dateFrom: null,
    dateTo: null,
    dateFromValue: null,
    dateToValue: null,
    hasCaption: true
  };
  private fileUploaded = false;

  private importRunning = false;
  public errors: string[] = [];

  public delimiterVal = () => {
    if (this.model.delimiter === 'semicolon') {
      return ';';
    }
    if (this.model.delimiter === 'tab') {
       return '    ';
    }
    if (this.model.delimiter === 'comma') {
      return ',';
    }
  }

  constructor(
    public globals: Globals,
    public dialogRef: MatDialogRef<PeakImportDialogComponent>,
    private uploadService: UploadService,
    private snackbar: MatSnackBar
  ) {
  }

  peakCsvUploaded(file) {
    this.model.csvFile = file;
    this.fileUploaded = true;
  }

  processCsvImport() {
    this.errors = [];
    this.importRunning = true;

    if (!this.model.csvFile) {
      this.errors.push('CSV soubor pro import nebyl zadán.');
    }

    if (this.model.importType === 'weekImport') {
      if (!this.model.dateFromValue) {
        this.errors.push('Není zadané datum od.');
      }
      if (!this.model.dateToValue) {
        this.errors.push('Není zadané datum do.');
      }

      if (!!this.model.dateFromValue && !!this.model.dateToValue && this.model.dateFromValue > this.model.dateToValue) {
        this.errors.push('Datum od je vyšší než datum do.');
      }
    }

    if (this.errors.length > 0) {
      this.importRunning = false;
      return;
    }

    if (!!this.model.dateFromValue) {
      this.model.dateFrom = toNetParameterDate(this.model.dateFromValue);
    }
    if (!!this.model.dateToValue) {
      this.model.dateTo = toNetParameterDate(this.model.dateToValue);
    }

    let suffix = '?dateFrom=' + this.model.dateFrom + '&dateTo=' + this.model.dateTo +
              '&delimiter=' + this.model.delimiter +
              '&hasCaption=' + (this.model.hasCaption ? 'true' : 'false');
    let imgRequest = this.uploadService.makeFileRequest('/api/peak/uploadcsv/' + this.model.importType + suffix, [], [this.model.csvFile]);
    imgRequest.subscribe(
      res => {
          if (res.length > 0) {
            let jsonRes = JSON.parse(res);
            this.snackbar.open('Naimportováno ' + (jsonRes.total - jsonRes.errors) +
                              ' z ' + jsonRes.total + ' záznamů. Neplatné záznamy byly vynechány',
                              'Zavřít', {duration: 4000});
            this.dialogRef.close('save');
          }
      },
      error => {
        this.errors.push('Nepodařilo se importovat CSV soubor.');
        if (error.length > 0) {
          let jsonRes = JSON.parse(error);
          this.errors.push(jsonRes.Message);
        }
      },
      () => {
        this.importRunning = false;
      });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/peak-import-dialog/peak-import-dialog.component.ts